import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { TextInputField } from '../../../components/FormCom/FormField';
import LeftArrowIcon from '../../../components/Icons/LeftArrowIcon';
import useForgotPassword from '../../../hooks/auth/admin/useForgotPassword';
import {
  ForgotPasswordDataType,
  forgotPasswordInitialValues,
  ForgotPasswordSchema,
} from '../../../models/auth/forgotPassword.model';
import {
  ACCOUNT,
  FORGOT_PASSWORD_NOTIFICATION,
  SIGNIN,
} from '../../../routes/routeConstants';

const ForgotPassword = () => {
  const { loading, forgotPassword, forgotPasswordError } = useForgotPassword();
  const navigate = useNavigate();

  const onSubmit = (value: ForgotPasswordDataType) => {
    forgotPassword(value, () => {
      navigate(`/${ACCOUNT}/${FORGOT_PASSWORD_NOTIFICATION}`);
    });
  };

  const backToSignIn = (e: any) => {
    navigate(`/${ACCOUNT}/${SIGNIN}`);
  };

  return (
    <Container>
      <FormWrapper>
        <FormHeader>
          <div className='title'>Reset Password</div>
          <div className='description'>
            Kindly enter your email and we'll send you a password reset link.
          </div>
        </FormHeader>

        <FormComponent
          initialValues={forgotPasswordInitialValues}
          schema={ForgotPasswordSchema}
          onSubmit={onSubmit}
        >
          <TextInputField
            label='Email Address'
            name='email'
            id='email'
            type='email'
            placeholder='name@mail.com'
          />

          {forgotPasswordError && (
            <InvalidOTP>{`${forgotPasswordError} This email doesn't exist.`}</InvalidOTP>
          )}

          <FormButtonArea>
            <FormSubmitButton
              onClick={backToSignIn}
              btnType='button'
              className='clear large'
            >
              <LeftArrowIcon /> Go Back
            </FormSubmitButton>
            <FormSubmitButton className='large' loading={loading}>
              Submit
            </FormSubmitButton>
          </FormButtonArea>
        </FormComponent>
      </FormWrapper>
    </Container>
  );
};

export default ForgotPassword;

const Container = styled.div`
  display: flex;
  height: 100vh;
  color: ${({ theme }) => theme.palette.grayTextColor};
  background-color: white;
  /* background-color: ${({ theme }) => theme.palette.pageBgColor}; */
`;

const FormButtonArea = styled.div`
  display: grid;
  grid-template-columns: 140px auto;
  gap: 24px;
  margin-top: 12px;
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 400px;
  align-self: center;
  gap: 24px;
  margin: auto;

  @media (max-width: 480px) {
    width: 100%;
    max-width: 400px;
    padding: 0 20px;
  }
`;

const FormHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;
  margin-bottom: 4px;

  & > .title {
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    color: ${({ theme }) => theme.palette.logirateBlack};
  }

  & > .description {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
  }
`;

const InvalidOTP = styled.div`
  display: flex;
  text-align: center;
  padding: 16px 108px;
  background-color: ${({ theme }) => theme.palette.warningBgColor};
  color: ${({ theme }) => theme.palette.warningTextColor};
  border-radius: 8px;
  font-weight: 500;
  line-height: 16px;
  font-size: 16px;
  margin-top: -16px;
`;
